import { User } from '@vendasta/iamv2';
import { UserWithDisplayName } from './tokens-and-interfaces';
import { GalaxyDateDefault, GalaxyFilterInterface, GalaxyFilterOperator } from '@vendasta/galaxy/filter/chips';
import {
  FilterGroupInterface,
  FilterValueInterface,
} from '@vendasta/crm/lib/_internal/interfaces/galaxy-filters.interface';
import { DateDefault, FilterGroupOperator, FilterInterface, FilterOperator } from '@vendasta/crm';

export function userFilterFn(user: UserWithDisplayName, searchTerm: string): boolean {
  searchTerm = searchTerm?.toLowerCase();
  const includesFullName = user.displayName.toLowerCase().includes(searchTerm);
  const includesFirstName = user.firstName.toLowerCase().includes(searchTerm);
  const includesLastName = user.lastName.toLowerCase().includes(searchTerm);
  const includesUserId = user.userId.toLowerCase().includes(searchTerm);
  const includesEmail = user.email.toLowerCase().includes(searchTerm);
  return includesFullName || includesFirstName || includesLastName || includesUserId || includesEmail;
}

export function convertToReadableUsers(users: User[]): UserWithDisplayName[] {
  return users.map(
    (user) =>
      ({
        ...user,
        displayName: `${user?.firstName ?? ''} ${user?.lastName ?? ''}`.trim() ?? user?.userId,
      }) as UserWithDisplayName,
  );
}

export function convertGalaxyFilters(filters: GalaxyFilterInterface[] | undefined): FilterGroupInterface | undefined {
  if (!filters) {
    return undefined;
  }
  const filterGroup = {} as FilterGroupInterface;
  filterGroup.operator = FilterGroupOperator.FILTER_GROUP_OPERATOR_AND;
  filterGroup.filters = [];
  filters.forEach((inputFilter) => {
    if (!inputFilter.fieldId || !inputFilter.operator) {
      return;
    }
    const filterOperator: FilterOperator = inputFilter.operator
      ? FilterOperator[GalaxyFilterOperator[inputFilter.operator]]
      : undefined;
    const filterGroupFilter: FilterInterface = {
      fieldId: inputFilter.fieldId,
      operator: filterOperator,
      values: [],
      floatTolerance: inputFilter.floatTolerance,
    };
    filterGroupFilter.values = inputFilter.values?.map((v) => {
      const dateDefault: DateDefault = v.dateDefault ? DateDefault[GalaxyDateDefault[v.dateDefault]] : undefined;
      return {
        boolean: v.boolean,
        integer: v.integer,
        string: v.string,
        date: v.date,
        dateDefault: dateDefault,
        float: v.float,
      } as FilterValueInterface;
    });
    filterGroup.filters?.push(filterGroupFilter);
  });
  return filterGroup;
}
